import { render, staticRenderFns } from "./saddle-e-tape.vue?vue&type=template&id=b7e5b7ec&scoped=true"
import script from "./saddle-e-tape.vue?vue&type=script&lang=js"
export * from "./saddle-e-tape.vue?vue&type=script&lang=js"
import style0 from "./saddle-e-tape.vue?vue&type=style&index=0&id=b7e5b7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e5b7ec",
  null
  
)

export default component.exports